/** Spinning cassette reels — matches Carpe Diem (brevity_app) TapeReels. */
function Cog() {
  return (
    <svg viewBox="0 0 64 64" className="size-full" aria-hidden>
      <circle cx="32" cy="32" r="30" fill="#4b5563" stroke="#9ca3af" strokeWidth="2" />
      <circle cx="32" cy="32" r="22" fill="#374151" stroke="#6b7280" strokeWidth="1.5" />
      {[0, 60, 120, 180, 240, 300].map((deg) => (
        <rect
          key={deg}
          x="29"
          y="8"
          width="6"
          height="14"
          rx="1"
          fill="#9ca3af"
          transform={`rotate(${deg} 32 32)`}
        />
      ))}
      <circle cx="32" cy="32" r="8" fill="#1f2937" stroke="#d1d5db" strokeWidth="2" />
      <circle cx="32" cy="32" r="3" fill="#9ca3af" />
    </svg>
  )
}

interface TapeReelsProps {
  /** When false, reels are shown but not spinning (idle / locking-in). */
  spinning?: boolean
  className?: string
}

export function TapeReels({ spinning = true, className = '' }: TapeReelsProps) {
  const reelClass = spinning ? 'tape-reel' : 'tape-reel-static'

  return (
    <div
      className={`pointer-events-none flex w-full items-center justify-between px-[24px] ${className}`}
      aria-hidden
    >
      <div className="size-[22%] max-w-[2.56rem] min-w-[1.4rem] aspect-square translate-x-[calc(100%-5px)] -translate-y-[calc(50%-5px)]">
        <div className={`${reelClass} size-full`}>
          <Cog />
        </div>
      </div>
      <div className="size-[22%] max-w-[2.56rem] min-w-[1.4rem] aspect-square -translate-x-[calc(100%-5px)] -translate-y-[calc(50%-5px)]">
        <div className={`${reelClass} size-full`}>
          <Cog />
        </div>
      </div>
    </div>
  )
}
